/* eslint-disable eqeqeq */
/* eslint-disable spaced-comment */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import { NumericFormat } from "react-number-format";
import PopUp from "./Popup";
import { isMobile } from "react-device-detect";
import { UmbracoContext, UmbracoStep } from "components/Umbraco/UmbracoContext";

import utils from "utils";
import { Button, InnerBig, Line, Row } from "meitav-uikit";

const { UmbracoUtills, rest } = utils;

export default function Section1(props) {
  const { lobbyDetailsData } = props;
  const [open, setOpen] = useState(false);

  const resource = UmbracoStep(useContext(UmbracoContext).resource, "Section1");
  const resourcePopUp = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopupStartOver"
  );
  const [readMore, setReadMore] = useState(false);

  const readMoreClick = () => {
    setReadMore(!readMore);
  };
  const changeProfile = async () => {
    window.dataLayer.push({
      event: "PM - ivestment",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "הרכב תיק ההשקעות",
        action_name: "אישור שינוי הרכב התיק",
      },
    });

    const investPolicyGUID = localStorage.getItem("investPolicyGUID");
    const result = await rest.get(
      `/api/Manager/ChangeUserPorfile?guid=${investPolicyGUID}`
    );
    window.open(`/CustomerInvestPolicy`, "_self");
  };

  const showChatCommbox = UmbracoUtills.getValueByKey(
    resource,
    "showChatCommbox"
  );
  if (showChatCommbox === "True" && !document.getElementById("connectScript")) {
    const script = document.createElement("script");
    script.id = "connectScript";
    script.src = "//apps.commbox.io//Scripts/connect.js";
    script.onload = () => {
      if (window.BY) {
        window.BY.chat({
          baseDomain: "commbox.io/",
          appsSubDomain: "apps",
          streamId: "pEs3A48EEgBZq_f07v29YQw%3d%3d",
          trackerStreamId: "6E72AsLXk6gLVtWt61Lo9A%3d%3d",
        });
      }
    };
    document.head.appendChild(script);
  }
  return (
    <div className="section1 ">
      <InnerBig className="wrapper">
        <div className={`${isMobile ? "containerMobile" : ""}`}>
          <Row type="small">
            <div className="myInvestment">
              <h1 className="h1Accibility">
                {UmbracoUtills.getParsedHtmlValueByKey(
                  resource,
                  "myInvestment"
                )}
              </h1>
            </div>
            <NumericFormat
              className="depositSum"
              value={` ${Number.parseFloat(lobbyDetailsData.depositSum)}`}
              displayType="text"
              thousandSeparator
              prefix="₪"
            />
          </Row>
          <Row>
            <div className="borderSection1" />
            <div className="pre-title">
              <h4 className="h1Accibility">
                {UmbracoUtills.getParsedHtmlValueByKey(resource, "title")}
              </h4>
            </div>
          </Row>
          <Row>
            <div className="riskLevelName">
              {`${lobbyDetailsData.riskLevelName} [${lobbyDetailsData.riskLevel}/5]`}
            </div>

            <Line aria-hidden="true" className="scalaRisk">
              <div className="scalaRiskLevel">
                {lobbyDetailsData.riskLevelFirstName}
              </div>
              <div
                className={`scala scala1 ${
                  lobbyDetailsData.riskLevel == 1 ? "scala1shadow" : ""
                }`}
              />
              <div
                className={`scala scala2 ${
                  lobbyDetailsData.riskLevel == 2 ? "scala2shadow" : ""
                }`}
              />
              <div
                className={`scala scala3 ${
                  lobbyDetailsData.riskLevel == 3 ? "scala3shadow" : ""
                }`}
              />
              <div
                className={`scala scala4 ${
                  lobbyDetailsData.riskLevel == 4 ? "scala4shadow" : ""
                }`}
              />
              <div
                className={`scala scala5 ${
                  lobbyDetailsData.riskLevel == 5 ? "scala5shadow" : ""
                }`}
              />
              <div className="scalaRiskLevel">
                {lobbyDetailsData.riskLevelEndName}
              </div>
            </Line>
          </Row>
          <Row>
            {isMobile ? (
              <div>
                <div className="readMore">
                  {`${
                    readMore
                      ? ""
                      : UmbracoUtills.getParsedHtmlValueByKey(
                          resource,
                          "readMore"
                        )
                  }`}
                </div>
                <div>
                  <div className="readMore">
                    {!readMore ? (
                      <img className="arrow-down" onClick={readMoreClick} />
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            {(isMobile && readMore) || !isMobile ? (
              <div>
                <div className={`${isMobile ? "row " : ""} description`}>
                  {lobbyDetailsData.riskLevelForShow}
                  {/*UmbracoUtills.getParsedHtmlValueByKey(resource, 'description')*/}
                </div>
                <Row>
                  <div className="changeProfile">
                    <Button
                      variant="none"
                      component="span"
                      onClick={() => setOpen(!open)}
                      role="button"
                      text={UmbracoUtills.getParsedHtmlValueByKey(
                        resource,
                        "changeProfile"
                      )}
                    ></Button>
                  </div>
                </Row>
                <PopUp
                  openProp={open}
                  setOpen={setOpen}
                  okBtnClick={changeProfile}
                  icon={"restartIcon"}
                  resourceText={UmbracoUtills.getValueByKey(
                    resourcePopUp,
                    "text"
                  )}
                  resourceOkBtn={UmbracoUtills.getValueByKey(
                    resourcePopUp,
                    "okBtn"
                  )}
                  resourceCancelBtn={UmbracoUtills.getValueByKey(
                    resourcePopUp,
                    "cancelBtn"
                  )}
                />
              </div>
            ) : null}
            {readMore ? (
              <div>
                <div className="readMore">
                  <img className="arrow-up" onClick={readMoreClick} />
                </div>
              </div>
            ) : null}
          </Row>
        </div>
      </InnerBig>
    </div>
  );
}
